import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Order } from 'src/app/models/order';
import { OrderService, OrderFilters } from 'src/app/services/order.service';
import { Travel } from 'src/app/models/travel';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { TravelService } from 'src/app/services/travel.service';
import { LogisticEventsService, EventMessage } from 'src/app/services/logistic-events.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NativeDateAdapter}]
})
export class CalendarComponent implements OnInit {

  date:Date = new Date();
  selectedDate:string = "";
  all:{
    date:Date,
    orders:Order[],
    active:boolean,
  }[] = [];
  loading:boolean = false;

  selectedOrder:Order;
  travel:Travel;

  constructor(private orderServ:OrderService, private modal:NgbModal, private travelServ:TravelService, private logisticEvt:LogisticEventsService) {
    this.logisticEvt.wait(resp => {
      let data:EventMessage = JSON.parse(resp.data);

      if (data.type == 'travel-created' || data.type == 'travel-deleted') {
        data.travel.lines.forEach(line => {
          if (line.order_id) {
            this.all.forEach(a => {
              let ord = a.orders.find(order => order.id == line.order_id);
              if (ord) {
                ord.status = data.type == 'travel-created' ? "Viaje Creado" : "Creada";
                ord.contracted = data.type == 'travel-created' ? data.travel.contracted : false;
              }
            });
          }
        });
      } else if (data.type == 'order-deleted') {//LISTO
        //Cancelado
        data.order.delivery_date = new Date(data.order.delivery_date);
        let section = this.all.find(a => a.date.getDate() == data.order.delivery_date.getDate() && a.date.getMonth() == data.order.delivery_date.getMonth() && a.date.getFullYear() == data.order.delivery_date.getFullYear());

        let or = section.orders.find(o => o.id == data.order.id);
        or.status = 'Cancelado';
      } else if (data.type == 'order-created') {//LISTO
        //insert into array
        data.order.delivery_date = new Date(data.order.delivery_date);
        let section = this.all.find(a => a.date.getDate() == data.order.delivery_date.getDate() && a.date.getMonth() == data.order.delivery_date.getMonth() && a.date.getFullYear() == data.order.delivery_date.getFullYear());

        data.order.status = 'Creada';
        section.orders.push(data.order);
      } else if (data.type == 'order-info-changed') {//LISTO
        //update order in array
        data.order.delivery_date = new Date(data.order.delivery_date);
        for (let i = 0; i < this.all.length; i++) {
          let orders = this.all[i].orders.filter(o => o.id != data.order.id);
          if (orders.length != this.all[i].orders.length) {
            this.all[i].orders = orders;
            break;
          }
        }

        let section = this.all.find(a => a.date.getDate() == data.order.delivery_date.getDate() && a.date.getMonth() == data.order.delivery_date.getMonth() && a.date.getFullYear() == data.order.delivery_date.getFullYear());

        section.orders.push(data.order);
      }
    });
  }

  ngOnInit() {
    this.getOrders();
  }

  calcDates(dateI:Date, dateF:Date, orders:Order[]) {
    this.all = [];

    let date1 = new Date(dateI.valueOf());
    for ( let i = 1; date1.valueOf() <= dateF.valueOf(); i++ ) {
      this.all.push({
        date: date1,
        orders: orders.filter(order => {
          return order.delivery_date.toString().substring(0, 10) == date1.toString();
        }),
        active: this.date.toString() == date1.toString(),
      });
      
      date1 = new Date(dateI.valueOf());
      date1.setDate(date1.getDate() + i);

      if (i == 37) break;
    }
  }

  getOrders() {
    let date = new Date(this.date.getFullYear(), this.date.getMonth(), 1, 1, 1, 1);
    date.setDate(date.getDay() == 0 ? -5 : date.getDate() - date.getDay() + 1 );
    let date2 = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0, 1, 1, 1);

    let months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    this.selectedDate = months[this.date.getMonth()] + ' ' + this.date.getFullYear();

    let filter:OrderFilters = {
      date1: date,
      date2: date2,
      status: null,
      user: null,
    }

    this.loading = true;
    this.orderServ.getOrders(filter).then(orders => {
      this.loading = false;
      this.calcDates(date, date2, orders);
    });
  }

  selected($event, mo) {
    this.selectedOrder = $event;
    if (this.selectedOrder.status != 'Cancelado' && this.selectedOrder.status != 'Creada') {
      this.loading = true;
      this.travelServ.getTravelByOrder(this.selectedOrder).then(travel => {
        this.travel = travel;
        this.loading = false;
      });
    } else {
      this.travel = null;
    }
    this.modal.open(mo, { size: 'lg' });
  }

}
